// Empreinte d'appareil (anti-doublon d'essai gratuit). Signature stable des
// caractéristiques matérielles/navigateur — survit à l'effacement du localStorage.
function hashStr(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
  return (h >>> 0).toString(36);
}

export function getDeviceFp() {
  try {
    const n = navigator;
    const signals = [
      n.userAgent, n.language, (n.languages || []).join(","),
      n.platform, n.hardwareConcurrency, n.deviceMemory,
      `${screen.width}x${screen.height}x${screen.colorDepth}`,
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      new Date().getTimezoneOffset(),
    ].join("|");
    return "fp_" + hashStr(signals) + hashStr(signals.split("").reverse().join(""));
  } catch {
    return null;
  }
}
